import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/app/[locale]/branchen/industries-overview.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/node_modules/next/dist/client/link.js");
